import { Grid } from '@material-ui/core'
import React, { useState } from 'react'

import SelectInput from '../../../../components/filter-input'
import { useStyles } from './styles'

export interface Filters {
  order: string
  solution: string
  culture: string
  project: string
  status: string
}

export interface FilterOptions {
  order: string[]
  solution: string[]
  culture: string[]
  project: string[]
  status: string[]
}

export interface FilterProps {
  filters: Filters
  filterOptions: FilterOptions
  onFilterChange: (filters: Filters) => void
}

export default function FilterPanel({
  filters,
  filterOptions,
  onFilterChange,
}: FilterProps) {
  const classes = useStyles()
  const [currentFilters, setCurrentFilters] = useState(filters)

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
  ) => {
    const { name, value } = event.target
    if (name) {
      const newFilters = {
        ...currentFilters,
        [name]: value as string,
      }
      setCurrentFilters(newFilters)
      onFilterChange(newFilters)
    }
  }

  return (
    <div className={classes.filter}>
      <Grid container spacing={2} className={classes.grid}>
        <Grid item xs={4}>
          <div className={classes.filterInputs}>
            <SelectInput
              label='Ordenação:'
              options={filterOptions.order}
              value={filters.order}
              onChange={handleChange}
              name='ordenacao'
            />
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={2} className={classes.grid}>
        <Grid item xs={8}>
          <div className={classes.filterInputs}>
            <SelectInput
              label='Solução:'
              options={filterOptions.solution}
              value={filters.solution}
              onChange={handleChange}
              name='solucao'
            />
            <SelectInput
              label='Cultura:'
              options={filterOptions.culture}
              value={filters.culture}
              onChange={handleChange}
              name='cultura'
            />
            <SelectInput
              label='Projeto:'
              options={filterOptions.project}
              value={filters.project}
              onChange={handleChange}
              name='projeto'
            />
            <SelectInput
              label='Status:'
              options={filterOptions.status}
              value={filters.status}
              onChange={handleChange}
              name='status'
            />
          </div>
        </Grid>
      </Grid>
    </div>
  )
}
